import { render, staticRenderFns } from "./ResidentialTownhouse.vue?vue&type=template&id=9cfaf970&scoped=true&"
import script from "./ResidentialTownhouse.vue?vue&type=script&lang=ts&"
export * from "./ResidentialTownhouse.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentialTownhouse.vue?vue&type=style&index=0&id=9cfaf970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfaf970",
  null
  
)

export default component.exports